// Display names of the video guide tags. The keys are the tag slugs used in videoGuideEntries.js (filtering works on the slug),
// the values are the visible labels written as [en, hu, de, cn].
// Every tag used by an entry must be listed here with all four languages (checked by videoGuideTags.test.js).
const RAW = {
    "add-ons": ["add-ons", "kiegészítők", "Extras", "加料"],
    administration: ["administration", "adminisztráció", "Verwaltung", "管理"],
    alerts: ["alerts", "értesítések", "Benachrichtigungen", "提醒"],
    allergens: ["allergens", "allergének", "Allergene", "过敏原"],
    app: ["app", "alkalmazás", "App", "应用"],
    audit: ["audit", "napló", "Protokoll", "审计"],
    automation: ["automation", "automatizálás", "Automatisierung", "自动化"],
    backup: ["backup", "biztonsági mentés", "Datensicherung", "备份"],
    bar: ["bar", "pult", "Bar", "吧台"],
    barcode: ["barcode", "vonalkód", "Barcode", "条形码"],
    basics: ["basics", "alapok", "Grundlagen", "基础"],
    bi: ["BI", "BI", "BI", "BI"],
    "bill-split": ["bill split", "számlaosztás", "Rechnung teilen", "分账"],
    billing: ["billing", "számlázás", "Abrechnung", "计费"],
    blocks: ["tickets", "blokkok", "Bons", "小票单"],
    booking: ["booking", "foglalás", "Buchung", "预订"],
    branding: ["branding", "arculat", "Branding", "品牌"],
    "bulk-update": ["bulk update", "tömeges módosítás", "Massenänderung", "批量修改"],
    "call-center": ["call center", "telefonos ügyfélszolgálat", "Callcenter", "呼叫中心"],
    card: ["card", "bankkártya", "Karte", "银行卡"],
    cash: ["cash", "készpénz", "Bargeld", "现金"],
    "cash-register": ["cash register", "pénztárgép", "Kasse", "收银机"],
    cashier: ["cashier", "pénztáros", "Kassierer", "收银员"],
    categories: ["categories", "kategóriák", "Kategorien", "分类"],
    channels: ["channels", "csatornák", "Kanäle", "渠道"],
    chatgpt: ["ChatGPT", "ChatGPT", "ChatGPT", "ChatGPT"],
    cloud: ["cloud", "felhő", "Cloud", "云端"],
    communication: ["communication", "kommunikáció", "Kommunikation", "沟通"],
    compliance: ["compliance", "megfelelőség", "Compliance", "合规"],
    counter: ["counter", "pult", "Tresen", "柜台"],
    courier: ["courier", "futár", "Kurier", "配送员"],
    course: ["course", "fogás", "Gang", "上菜顺序"],
    "customer-data": ["customer data", "vevőadatok", "Kundendaten", "客户资料"],
    "customer-experience": ["customer experience", "vendégélmény", "Kundenerlebnis", "顾客体验"],
    dashboards: ["dashboards", "dashboardok", "Dashboards", "仪表板"],
    delivery: ["delivery", "kiszállítás", "Lieferung", "外送"],
    design: ["design", "tervezés", "Gestaltung", "设计"],
    digital: ["digital", "digitális", "digital", "数字化"],
    "dine-in": ["dine-in", "helyben fogyasztás", "Vor-Ort-Verzehr", "堂食"],
    discount: ["discount", "kedvezmény", "Rabatt", "折扣"],
    dispatch: ["dispatch", "kiosztás", "Disposition", "调度"],
    display: ["display", "kijelző", "Display", "显示屏"],
    documentation: ["documentation", "dokumentáció", "Dokumentation", "文档"],
    examples: ["examples", "példák", "Beispiele", "示例"],
    excel: ["Excel", "Excel", "Excel", "Excel"],
    export: ["export", "exportálás", "Export", "导出"],
    feedback: ["feedback", "visszajelzés", "Feedback", "反馈"],
    filters: ["filters", "szűrők", "Filter", "筛选"],
    fiscal: ["fiscal", "fiskális", "Fiskal", "税控"],
    franchise: ["franchise", "franchise", "Franchise", "加盟"],
    guest: ["guest", "vendég", "Gast", "顾客"],
    "guest-call": ["guest call", "vendéghívás", "Gästeruf", "顾客呼叫"],
    "guest-experience": ["guest experience", "vendégélmény", "Gästeerlebnis", "顾客体验"],
    hardware: ["hardware", "hardver", "Hardware", "硬件"],
    history: ["history", "előzmények", "Verlauf", "历史"],
    images: ["images", "képek", "Bilder", "图片"],
    import: ["import", "import", "Import", "导入"],
    included: ["included", "benne foglalt", "enthalten", "已包含"],
    inheritance: ["inheritance", "öröklés", "Vererbung", "继承"],
    integration: ["integration", "integráció", "Integration", "集成"],
    inventory: ["inventory", "leltár", "Inventur", "盘点"],
    kds: ["KDS", "KDS", "KDS", "KDS"],
    kiosk: ["kiosk", "kioszk", "Kiosk", "自助点餐机"],
    kitchen: ["kitchen", "konyha", "Küche", "后厨"],
    labels: ["labels", "címkék", "Labels", "标签"],
    "live-status": ["live status", "élő állapot", "Live-Status", "实时状态"],
    loyalty: ["loyalty", "hűség", "Treue", "会员忠诚"],
    mandatory: ["mandatory", "kötelező", "Pflicht", "必选"],
    map: ["map", "térkép", "Karte", "地图"],
    marketing: ["marketing", "marketing", "Marketing", "营销"],
    menu: ["menu", "étlap", "Speisekarte", "菜单"],
    mobile: ["mobile", "mobil", "mobil", "移动端"],
    monitoring: ["monitoring", "monitorozás", "Überwachung", "监控"],
    "multi-language": ["multi-language", "többnyelvűség", "Mehrsprachigkeit", "多语言"],
    "multi-location": ["multi-location", "több helyszín", "mehrere Standorte", "多门店"],
    ntak: ["NTAK", "NTAK", "NTAK", "NTAK"],
    operations: ["operations", "működés", "Betrieb", "运营"],
    "option-groups": ["option groups", "opciócsoportok", "Optionsgruppen", "选项组"],
    optional: ["optional", "opcionális", "optional", "可选"],
    options: ["options", "opciók", "Optionen", "选项"],
    "order-taking": ["order taking", "rendelésfelvétel", "Bestellaufnahme", "点单"],
    ordering: ["ordering", "rendelés", "Bestellung", "下单"],
    orders: ["orders", "rendelések", "Bestellungen", "订单"],
    override: ["override", "felülbírálás", "Überschreiben", "覆盖"],
    overview: ["overview", "áttekintés", "Überblick", "概览"],
    payment: ["payment", "fizetés", "Zahlung", "支付"],
    permissions: ["permissions", "jogosultságok", "Berechtigungen", "权限"],
    phone: ["phone", "telefon", "Telefon", "电话"],
    pickup: ["pickup", "elvitel", "Abholung", "自取"],
    planning: ["planning", "tervezés", "Planung", "规划"],
    pos: ["POS", "kassza", "Kasse", "收银台"],
    pricing: ["pricing", "árazás", "Preisgestaltung", "定价"],
    printing: ["printing", "nyomtatás", "Drucken", "打印"],
    product: ["product", "termék", "Produkt", "产品"],
    production: ["production", "gyártás", "Produktion", "生产"],
    profitability: ["profitability", "jövedelmezőség", "Rentabilität", "盈利能力"],
    purchasing: ["purchasing", "beszerzés", "Einkauf", "采购"],
    qr: ["QR", "QR-kód", "QR-Code", "二维码"],
    receiving: ["receiving", "bevételezés", "Wareneingang", "收货"],
    recipe: ["recipe", "recept", "Rezept", "配方"],
    recipes: ["recipes", "receptek", "Rezepte", "配方"],
    refund: ["refund", "visszatérítés", "Erstattung", "退款"],
    reports: ["reports", "riportok", "Berichte", "报表"],
    reservation: ["reservation", "foglalás", "Reservierung", "预订"],
    restaurants: ["restaurants", "éttermek", "Restaurants", "餐厅"],
    retention: ["retention", "ügyfélmegtartás", "Kundenbindung", "客户留存"],
    roles: ["roles", "szerepkörök", "Rollen", "角色"],
    scale: ["scale", "mérleg", "Waage", "电子秤"],
    scheduling: ["scheduling", "időzítés", "Zeitplanung", "排程"],
    "second-screen": ["second screen", "másodkijelző", "zweiter Bildschirm", "第二屏幕"],
    "self-service": ["self-service", "önkiszolgálás", "Selbstbedienung", "自助服务"],
    separate: ["separate", "különálló", "getrennt", "独立"],
    service: ["service", "felszolgálás", "Service", "服务"],
    serving: ["serving", "tálalás", "Ausgabe", "出餐"],
    servings: ["servings", "kiszerelések", "Portionsgrößen", "规格"],
    settings: ["settings", "beállítások", "Einstellungen", "设置"],
    setup: ["setup", "beüzemelés", "Einrichtung", "初始设置"],
    split: ["split", "megosztás", "Teilung", "拆分"],
    stats: ["statistics", "statisztika", "Statistik", "统计"],
    stock: ["stock", "készlet", "Bestand", "库存"],
    "stock-management": ["stock management", "készletkezelés", "Lagerverwaltung", "库存管理"],
    stocktaking: ["stocktaking", "leltározás", "Bestandsaufnahme", "盘点"],
    superadmin: ["super admin", "szuperadmin", "Superadmin", "超级管理员"],
    support: ["support", "támogatás", "Support", "支持"],
    "table-service": ["table service", "asztali felszolgálás", "Tischservice", "桌边服务"],
    tables: ["tables", "asztalok", "Tische", "桌位"],
    takeaway: ["takeaway", "elvitel", "Mitnahme", "外卖"],
    templates: ["templates", "sablonok", "Vorlagen", "模板"],
    terminal: ["terminal", "terminál", "Terminal", "终端"],
    tip: ["tip", "borravaló", "Trinkgeld", "小费"],
    tracking: ["tracking", "követés", "Verfolgung", "追踪"],
    transfer: ["transfer", "átvezetés", "Umbuchung", "调拨"],
    translation: ["translation", "fordítás", "Übersetzung", "翻译"],
    updates: ["updates", "frissítések", "Aktualisierungen", "更新"],
    upsell: ["upsell", "upsell", "Upsell", "追加销售"],
    users: ["users", "felhasználók", "Benutzer", "用户"],
    variations: ["variations", "variációk", "Varianten", "变体"],
    vat: ["VAT", "ÁFA", "MwSt.", "税率"],
    voice: ["voice", "hang", "Sprache", "语音"],
    waiter: ["waiter", "pincér", "Kellner", "服务员"],
    warehouse: ["warehouse", "raktár", "Lager", "仓库"],
    waste: ["waste", "selejt", "Ausschuss", "损耗"],
    weight: ["weight", "súly", "Gewicht", "重量"],
    wolt: ["Wolt", "Wolt", "Wolt", "Wolt"],
    workflow: ["workflow", "munkafolyamat", "Arbeitsablauf", "工作流程"]
};

const TAG_LABELS = {};
Object.keys(RAW).forEach(tag => {
    const [en, hu, de, cn] = RAW[tag];
    TAG_LABELS[tag] = { en, hu, de, cn };
});

// Visible label of a tag in the given language; falls back to English and then to the slug.
const getTagLabel = (tag, language) => {
    const labels = TAG_LABELS[tag];
    if (!labels) return String(tag).replace(/-/g, " ");
    return labels[language] || labels.en;
};

// Every language version of a tag, used by the search box so a guest can type the tag in any language.
const getAllTagLabels = (tag) => {
    const labels = TAG_LABELS[tag];
    return labels ? Object.values(labels) : [String(tag).replace(/-/g, " ")];
};

module.exports = { TAG_LABELS, getTagLabel, getAllTagLabels };
